<template>
    <Sidebar v-if="store.state.user_data" />
    <Content class="settings">
        <div :class="['inner inner-box', (store.state.user_data.merchant_accounts.length == 0) && 'inner-no-content' , (selected_type === 'team-setting') && 'inner-inside']"
            v-if="store.state.user_data && store.state.department_select">
            <Menu v-if="store.state.user_data.merchant_accounts.length > 0 && selected_type !== 'team-setting'" />
            <Account v-if="selected_type === 'account'" />
            <Team v-else-if="selected_type === 'team'" />
            <TeamSetting v-else-if="selected_type === 'team-setting'" />
            <Company v-else-if="selected_type === 'company'" />
            <DomainEdit v-else-if="selected_type === 'domain-edit'" />
            <ScriptManager v-else-if="selected_type === 'script'" />
            <StorefrontImg v-else-if="selected_type === 'storefront-img' || selected_type === 'content-listening' || selected_type === 'permissions'|| selected_type === 'term-setting' || selected_type === 'tiers'" />
        </div>
    </Content>
</template>

<script setup>
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';

import Sidebar from '@/components/Sidebar.vue';
import Content from '@/components/ui/Content.vue';
import Menu from '@/components/settings/Menu.vue';
import Account from '@/components/settings/YourAccount/Account.vue';
import Team from '@/components/settings/Team/Team.vue';
import TeamSetting from '@/components/settings/Team/TeamSetting.vue';
import Company from '@/components/settings/Company.vue';
import StorefrontImg from '@/components/settings/StorefrontImg.vue';
// import Domain from '@/components/settings/Domain.vue';
import DomainEdit from '@/components/settings/Domain/DomainEdit.vue';
import ScriptManager from '@/components/settings/ScriptManager.vue';
import { useStore } from 'vuex';

const route = useRoute();
const store = useStore();

const selected_type = ref('');

watch(
  () => route.params,
  (params) => {
    selected_type.value = params.type;
  },
  {
    immediate: true,
  }
);
</script>


<style lang="scss">
.settings {
    overflow: hidden;
    height: calc(100vh - 16px);
    &>.inner {
        height: -webkit-fill-available;
        padding: 24px 48px;//32px 48px;
        display: flex;
        position: relative;
        min-height: 0;
        height: 100%;
        &::before {
            position: absolute;
            width: 1px;
            top: 32px;
            bottom: 32px;
            left: 358px;
            content: '';
            background-color: rgba(0, 0, 0, 0.08);
        }

        &.inner-inside{
            display: block;
            &::before {
                display: none;
            }
        }
    }

    .settings-content {
        width: -webkit-fill-available;
        min-width: 600px;
        margin-left: 36px;
        padding: 0px 20px 0 64px;
        // border-left: 1px solid rgba(0, 0, 0, 0.08);

        .scrollbar-content {
            // height: 98%;
            padding-right: 20px;
        }
    }

    .inner-no-content {
        .settings-content {
            border-left: none;
        }

        &.inner::before{
            display: none;
        }
    }

    .btn-box {
        display: flex;
        justify-content: flex-end;

        .ui-button {
            margin-right: 10px;

            &:last-child {
                margin-right: 0;
            }
        }

    }

    .confirm-modal-small {
        .ui-modal--container {
            width: 314px;
        }

        .contain-box-confirm {
            padding: 24px;

            .confirm-title {
                font: var(--font-demi-20);
                color: var(--black-90);
                margin-bottom: 10px;
            }

            .text {
                font-family: var(--font);
                font-size: 16px;
                color: var(--black-75);
            }
        }
    }

    .confirm-btn-box {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        margin-top: 24px;

        .confirm-btn {
            padding: 0 48px;
        }
    }
}
</style>